
import React from "react";
import styles from "../../assets/style.module.css";

export interface PageHeadProps {
    title: string;
    kicker?: string;
    titleEm?: string;
    subtitle?: string;
}

function PageHead({ kicker, title, titleEm, subtitle }: PageHeadProps) {
    return (<div className={styles["page-head"]}>
        <div className={styles["container"]}>
            {kicker && (<div className={styles["kicker"]}>{kicker}</div>)}
            <h1 className={styles["title"]}>{title}{titleEm && (<> <em>{titleEm}</em></>)}</h1>
            {subtitle && (<p className={styles["sub"]} style={{ color: "var(--muted-light)" }}>{subtitle}</p>)}
        </div>
    </div>);
}

export default PageHead;
